import { render, staticRenderFns } from "./PeriodAt.vue?vue&type=template&id=091980bd&scoped=true&"
import script from "./PeriodAt.vue?vue&type=script&lang=ts&"
export * from "./PeriodAt.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodAt.vue?vue&type=style&index=0&id=091980bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091980bd",
  null
  
)

export default component.exports